export default __webpack_public_path__ + "static/media/3.fe309fcd.jpeg";